<template>
  <b-navbar toggleable type="light" >
      <b-navbar-brand href="/">
      <img src="../assets/webLogoNegro.svg" alt="">
    </b-navbar-brand>

    <b-navbar-toggle target="navbar-toggle-collapse">
    </b-navbar-toggle>

    <b-collapse id="navbar-toggle-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item href="/about">Conózcanos</b-nav-item>
        <b-nav-item href="/services">Nuestros servicios</b-nav-item>
        <b-nav-item href="/contact">Contáctenos</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {};
</script>

<style lang="css" scoped>
img {
  height: 80px;
  transition: 0.5s;
  cursor: pointer;
}
.navbar-light .navbar-toggler {
    background: var(--primary) !important;
}
</style>
